export default __webpack_public_path__ + "static/media/incorrect24.a9e3e29f.mp3";